import VehiclePanelContainer from './VehiclePanelContainer';

export default VehiclePanelContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/VehiclePanel/index.js